import type { ArtworkOption } from './digitalProofingArtworkTypes'
import { Input } from 'reactstrap'
import ArtworkPreviewSurface from './ArtworkPreviewSurface'
import { normalizedSelectionId, sortByPosition } from './digitalProofingArtworkFormUtils'

type ArtworkDropdownProps = {
  product: {
    allow_artwork?: boolean
    artwork_alias?: string
  }
  artworks: ArtworkOption[]
  selectedArtwork?: ArtworkOption | false | null
  selectedArtworkId: string
  isDigitalProofingProduct: boolean
  onSelectArtwork: (artworkId: string) => void
}

const artworkSelectOptions = (artworks: ArtworkOption[]) =>
  sortByPosition(artworks).map((artwork, index) => {
    const id = normalizedSelectionId(artwork)

    return (
      <option key={id ?? index} value={id}>
        {artwork.name || artwork.label}
      </option>
    )
  })

const ArtworkDropdown = ({
  product,
  artworks,
  selectedArtwork,
  selectedArtworkId,
  isDigitalProofingProduct,
  onSelectArtwork
}: ArtworkDropdownProps) => {
  if (!product.allow_artwork && !isDigitalProofingProduct) return null

  return (
    <div className="mf-mb-20 w-100">
      <h6>{product.artwork_alias}</h6>
      {artworks.length === 1 ? (
        <div className="mf-mb-20">{artworks[0].name}</div>
      ) : artworks.length > 0 ? (
        <Input type="select" value={selectedArtworkId} onChange={event => onSelectArtwork(event.target.value)}>
          <option disabled value="-1">
            {`Please select the desired  ${product.artwork_alias}`}
          </option>
          {artworkSelectOptions(artworks)}
        </Input>
      ) : (
        <div className="mf-mb-20">No artworks are available for this product</div>
      )}
      {selectedArtwork && selectedArtwork.image2 && (
        <>
          <br />
          <ArtworkPreviewSurface
            src={selectedArtwork.image2}
            alt={`${selectedArtwork.name || selectedArtwork.label || 'Artwork'} preview`}
            className="artwork-preview-surface--selected-artwork"
            maxHeight="260px"
          />
        </>
      )}
    </div>
  )
}

export default ArtworkDropdown
